import { useCurrentOrganization } from '~publish/contexts/AccountContext'

function useConnectedChannelsCount(): number {
  const currentOrganization = useCurrentOrganization()
  const channelCount = currentOrganization?.channels?.length || 0
  return channelCount
}

export default useConnectedChannelsCount
